import { z } from 'zod'

export const workTaskTrackerReadinessResponseSchema = z.object({}).passthrough()
export type WorkTaskTrackerReadinessResponse = z.infer<typeof workTaskTrackerReadinessResponseSchema>
